import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import {
  downloadConversion,
  downloadAttributeFile,
  downloadParagonFile,
  downloadConversionZip,
  downloadAttributeFileZip,
  downloadTemplateFile,
  downloadMappingFile,
  downloadMappingZip,
} from '../../../api';

import { addMessage } from '../../../store/actions/message.actions';

const styles = theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
});

class DownloadContainer extends React.Component {
  constructor(props) {
    super(props);

    this.downloadFile = this.downloadFile.bind(this);

    this.state = {
      isDownloading: false,
    };
  }

  downloadFile(e) {

    this.setState({ isDownloading: true });

    const { sessionId, fileId, type } = this.props;

    let download;
    switch (type) {
      case 'attribute':
        download = downloadAttributeFile;
        break;
      case 'paragon':
        download = downloadParagonFile;
        break;
      case 'conversionZip':
        download = downloadConversionZip;
        break;
      case 'attributeZip':
        download = downloadAttributeFileZip;
        break;
      case 'templateFile':
        download = downloadTemplateFile;
        break;
      case 'mappingFile':
        download = downloadMappingFile;
        break;
      case 'mappingZip':
        download = downloadMappingZip;
        break;
      default:
        download = downloadConversion;
    }

    download(sessionId, fileId)
      .then(({ filename, data }) => {
        const anchor = document.createElement('a');
        document.body.appendChild(anchor);
        anchor.style = 'display: none';

        const blob = new Blob([data], { type: 'octet/stream' });
        const url = window.URL.createObjectURL(blob);

        anchor.href = url;
        anchor.download = filename;
        anchor.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(anchor);

        this.setState({ isDownloading: false });
        this.props.callback();
      }).catch(({ message }) => {
        this.props.addMessage('error', message);
        this.setState({ isDownloading: false });
        this.props.callback();
      });
  }

  render() {
    return (
      <Button
        onClick={this.downloadFile}
        disabled={this.state.isDownloading || this.props.disabled}
        color="primary"
      >
        {
        this.state.isDownloading ?
          <CircularProgress className={this.props.classes.icon} size={20} color="primary" disableShrink={true}/> :
          <Icon className={this.props.classes.icon}>{this.props.icon}</Icon>
        }

        {this.props.buttonText}
      </Button>
    );
  }
}

DownloadContainer.propTypes = {
  sessionId: PropTypes.string.isRequired,
  fileId: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf(['conversion', 'attribute', 'paragon', 'conversionZip', 'attributeZip', 'templateFile', 'mappingFile', 'mappingZip']).isRequired,
  disabled: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  addMessage: PropTypes.func.isRequired,
  callback: PropTypes.func,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

DownloadContainer.defaultProps = {
  fileId: null,
  icon: 'get_app',
  disabled: false,
  callback: () => null,
};

export default withStyles(styles)(connect(null, { addMessage })(DownloadContainer));
